import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { SixInOne } from './components/SixInOne';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { ToolkitSection } from './components/ToolkitSection';
import { ValueStack } from './components/ValueStack';
import { PricingSection } from './components/PricingSection';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
const META_PIXEL_ID = '1049314170929647';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    const w = window as any;
    try {
      if (!w.fbq) {
        const n: any = w.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!w._fbq) w._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const target = document.head || document.body || document.documentElement;
        if (target) target.appendChild(script);
        w.fbq('init', META_PIXEL_ID);
      }
      w.fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init failed:', err);
    }
  }, []);
  return <div className="min-h-screen w-full bg-cream text-ink texture-concrete selection:bg-burgundy/20 selection:text-burgundy" data-id="element-0" data-mp="sudoanf90dch">
      <noscript data-id="element-1" data-mp="35gmx6tbedlm">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="34x2njg6zd4f" />
      </noscript>

      <main data-id="element-3" data-mp="d2bj3j2481wq">
        <Hero data-id="element-4" data-mp="85l1granwy97" />
        <TestimonialsStrip data-id="element-5" data-mp="851lvh8hilyc" />
        <PainPoints data-id="element-6" data-mp="86w58r43y60b" />
        <SolutionReveal data-id="element-7" data-mp="86ckz3qzj5j4" />
        <SixInOne data-id="element-8" data-mp="3gle9ehqxh1en" />
        <TomosSection data-id="element-9" data-mp="3gkv2dw2tfxfe" />
        <BonusSection data-id="element-10" data-mp="3gm64lrgm4x4e" />
        <ToolkitSection data-id="element-11" data-mp="3glny8208l2ir" />
        <ValueStack data-id="element-12" data-mp="3bmbehq4nwbke" />
        <PricingSection data-id="element-13" data-mp="3bmthr6pqrq1t" />
        <ExtendedTestimonials data-id="element-14" data-mp="3bnmgbkejr98v" />
        <Guarantee data-id="element-15" data-mp="3bk71miosc27z" />
        <FAQ data-id="element-16" data-mp="3qb7jfebf98gs" />
        <FinalCTA data-id="element-17" data-mp="3qbpon0g2ax0u" />
      </main>
      <Footer data-id="element-18" data-mp="3qbzf0p50r672" />
      <PurchaseNotifications data-id="element-19" data-mp="3qcim1at4sa6b" />
    </div>;
}